<template>
  <div class="form-group base-select" :class="{ 'has-label': label, 'has-danger': error, disabled: disabled }">
    <label v-if="label" class="form-control-label">
      {{ label }}
    </label>
    <div class="selection form-control" :class="{ 'is-invalid': error }" ref="selection">
      <ul :class="{ readonly: readonly }" class="selection-render d-flex" @click="clickSelection">
        <!-- <span class="selection-render__clear">×</span> -->
        <li class="selection-render__choice d-flex mt-1" v-for="(item, index) in arrSelected" :key="index">
          <slot name="selected" v-bind="{ index, item }">
            <span v-if="item.text">{{ item.text }}</span>
            <span v-else>{{ item }}</span>
          </slot>
          <span @click="removeSelect(index)" class="selection-render__choice__remove ml-2" role="">×</span>
        </li>
        <li class="selection-search">
          <input
            class="selection-search__field"
            :class="{ disabled: disabled }"
            :disabled="disabled"
            :readonly="readonly"
            type="search"
            tabindex="0"
            autocomplete="off"
            autocorrect="off"
            autocapitalize="off"
            spellcheck="false"
            role="textbox"
            aria-autocomplete="list"
            :placeholder="placeholder"
            ref="inputText"
            @keydown="inputTextKeyDown"
            :style="`width:${widthInput}px; `"
            v-click-outside="closeSearch"
            v-model="inputText"
            @click="inputFocus = true"
          />
        </li>
      </ul>
      <ul
        v-if="inputFocus"
        class="selection-list"
        ref="selectionList"
        :style="`width:${$refs.selection.clientWidth}px;`"
      >
        <template v-if="arrOptions.length > 0">
          <li
            @click="doChoice(item)"
            v-for="(item, index) in arrOptions"
            :key="index"
            :class="{ active: indexFocusList == index }"
          >
            <slot name="body" v-bind="{ index, item }">
              <span v-if="item.text">{{ item.text }}</span>
              <span v-else>{{ item }}</span>
            </slot>
          </li>
        </template>
        <template v-else>
          <li v-if="pending">
            <div class="text-center pt-2">
              <b-icon icon="stopwatch" font-scale="3" animation="cylon"></b-icon>
              <p id="cancel-label" class="mb-2">
                Đang tải dữ liệu,Chờ chút nhé...
              </p>
            </div>
          </li>
          <li v-else-if="arrSelected.length == 0">
            không tìm thấy dữ liệu
          </li>
          <li v-else>
            Đã được chọn
          </li>
        </template>
      </ul>
      <div v-if="disabled" class="disabled"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'base-select',
  props: {
    error: {},
    disabled: {},
    value: {},
    readonly: {},
    label: {
      type: String,
      default: '',
      description: 'label of input'
    },
    ajaxData: {
      type: Function
    },
    mutiple: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    },
    placeholder: {}
  },
  data() {
    return {
      inputText: '',
      arrSelected: this.value ? [this.value] : [],
      arrOptions: this.options,
      widthInput: 10,
      inputFocus: false,
      timerSearch: null,
      pending: false,
      indexFocusList: 0,
      ofsetInput: 0
    };
  },
  mounted() {
    //this.widthInput = this.$refs.selection.clientWidth - 40;
  },
  methods: {
    inputTextKeyDown($event) {
      this.inputFocus = true;
      if ($event.code == 'Enter') {
        $event.preventDefault();
        if (this.arrOptions.length > this.indexFocusList) {
          let item = this.arrOptions[this.indexFocusList];
          this.doChoice(item);
        }
      } else if ($event.code == 'ArrowDown') {
        this.indexFocusList++;
        if (this.indexFocusList > this.arrOptions.length - 1) {
          this.indexFocusList = this.arrOptions.length - 1;
        }
      } else if ($event.code == 'ArrowUp') {
        this.indexFocusList--;
        if (this.indexFocusList < 0) {
          this.indexFocusList = 0;
        }
      } else if ($event.code == 'Backspace' && $event.target.value.length == 0) {
        if (this.arrSelected.length > 0) {
          this.arrSelected.splice(this.arrSelected.length - 1, 1);
          if (this.mutiple) {
            this.$emit('input', this.arrSelected);
            this.$emit('change', this.arrSelected);
          } else {
            if (this.arrSelected.length == 0) {
              this.$emit('input', '');
              this.$emit('change', '');
            } else {
              this.$emit('input', this.arrSelected[0]);
              this.$emit('change', this.arrSelected[0]);
            }
          }
        }
      }
      let tmpWidth = ($event.target.value.length + 1) * 9.15;
      this.widthInput = tmpWidth > 80 ? tmpWidth : tmpWidth;
    },
    closeSearch() {
      this.inputFocus = false;
    },
    doChoice(item) {
      if (this.mutiple) {
        this.arrSelected.push(item);
        this.$emit('input', this.arrSelected);
        this.$emit('change', this.arrSelected);
      } else {
        this.inputFocus = false;
        this.arrSelected = [item];
        this.inputText = '';
        this.widthInput = 10;
        this.$emit('input', this.arrSelected[0]);
        this.$emit('change', this.arrSelected[0]);
      }
    },
    removeSelect(index) {
      this.arrSelected.splice(index, 1);
      if (this.mutiple) {
        this.$emit('input', this.arrSelected);
        this.$emit('change', this.arrSelected);
      } else {
        this.$emit('input', this.arrSelected[0]);
        this.$emit('change', this.arrSelected[0]);
      }
    },
    getData(keyword) {
      if (this.ajaxData) {
        var self = this;
        this.pending = true;
        this.ajaxData(keyword, datas => {
          // self.arrOptions = datas;
          this.pending = false;
          self.checkExistSelected(datas);
        });
      } else {
        this.arrOptions = this.options.filter(item => {
          let keysCheck = Object.keys(item);
          // let keysCheck = ["name", "phone", "address", "email"];
          for (let i = 0; i < keysCheck.length; i++) {
            const key = keysCheck[i];
            let value = item[key];
            if (
              value &&
              value
                .toString()
                .toLowerCase()
                .includes(keyword.toLowerCase())
            ) {
              return true;
            }
          }
          return false;
        });
        //this.checkExistSelected(arrData);
      }
    },
    checkExistSelected(datas) {
      this.arrOptions = [];
      for (let j = 0; j < datas.length; j++) {
        const item = datas[j];
        let isExist = false;
        for (let i = 0; i < this.arrSelected.length; i++) {
          const element = this.arrSelected[i];
          if (element.id == item.id) {
            isExist = true;
          }
        }
        if (!isExist) {
          this.arrOptions.push(item);
        }
      }
    },
    clickSelection() {
      if (this.disabled) return;
      this.getData(this.inputText);
      this.inputFocus = true;
      this.$refs.inputText.focus();
    }
  },
  watch: {
    inputText: function() {
      var self = this;
      clearTimeout(this.timerSearch);
      this.timerSearch = setTimeout(() => {
        self.getData(self.inputText);
      }, 600);
    },
    value: function() {
      if (this.value) {
        if (this.mutiple) {
          this.arrSelected = this.value;
        } else {
          this.arrSelected = [this.value];
        }
      } else {
        this.arrSelected = [];
      }
    }
  }
};
</script>
<style lang="scss">
.base-select {
  margin-bottom: 0px;
  .selection {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
    border-bottom-color: transparent;
    // box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    //   0 0 8px rgba(102, 175, 233, 0.6);
    transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s;
    border-color: #66afe9;
    min-height: 34px;
    padding: 0;
    height: auto;
    background-color: #fff;
    border-radius: 4px;
    color: #555555;
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-size: 14px;
    outline: 0;
    box-sizing: border-box;
    position: relative;
    cursor: pointer;
    display: block;
    min-height: 25px;
    user-select: none;
    -webkit-user-select: none;
    &.is-invalid {
      border-color: #dc3545;
      padding-right: calc(1.5em + 0.75rem) !important;
      background-repeat: no-repeat;
      background-position: right calc(0.375em + 0.1875rem) center !important;
      background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
    }
    .selection-render {
      box-sizing: border-box;
      display: block;
      line-height: 1.428571429;
      list-style: none;
      margin: 0;
      overflow: hidden;
      padding: 0;
      width: 100%;
      text-overflow: ellipsis;
      white-space: nowrap;
      // border: 1px solid #ced4da;

      &.readonly {
        background: #e5e5e5;
      }
      .selection-render__clear {
        color: #999;
        cursor: pointer;
        float: right;
        font-weight: bold;
        margin-right: 10px;
        margin-top: 6px;
      }
      .selection-render__choice {
        color: #555555;
        background: #fff;
        border: 1px solid #ccc;
        border-radius: 4px;
        cursor: default;
        float: left;
        margin: 2px 0px 2px 2px;
        padding: 0px 6px;
        .selection-render__choice__remove {
          color: #999;
          cursor: pointer;
          display: inline-block;
          font-weight: bold;
          margin-right: 3px;
        }
      }
      .selection-search {
        float: left;
        .selection-search__field {
          background: transparent;
          padding-left: 10px;
          height: 30px;
          line-height: 1.428571429;
          margin-top: 0;
          min-width: 52px;
          box-sizing: border-box;
          border: none;
          font-size: 100%;
          outline: 0;
        }
      }
    }
    .selection-list {
      position: absolute;
      width: 100%;
      background: #fff;
      z-index: 99;
      border: 1px solid #ced4da;
      border-top: 1px solid #ebebeb;
      margin: 0;
      list-style: none;
      padding: 0px;
      max-height: 240px;
      overflow: hidden;
      overflow-y: auto;
      min-width: 200px;
      li {
        padding: 5px;
        border-bottom: 1px solid #ebebeb;
        &:hover {
          background: rgba(53, 197, 223, 0.37);
        }

        &.active {
          background: rgba(53, 197, 223, 0.37);
        }
      }
    }
  }
  &.disabled {
    .selection {
      cursor: not-allowed;
    }
  }
  .disabled {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 8;
    background: rgba(184, 186, 187, 0.25);
  }
}
</style>
